import {
  APP_INITIALIZED,
  AUTHENTICATION_ERROR,
  AUTHENTICATION_SUCCESS,
  CONNECTED,
  DISCONNECTED,
  SERVER_ERROR,
  PROACTIVE_TRIGGERED,
} from 'app/modules/app/constants';

import { USER_CREATE } from 'app/modules/user/constants';

const initialState = {
  // flag indicating that the app is ready to display (configuration fetched, login done etc)
  initialized: false,
  ready: false,
  clientReady: false,
  _authError: null,
  _serverError: null,
  proactiveTriggered: false,
};

export default function appReducer(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case APP_INITIALIZED:
      return {
        ...state,
        initialized: true,
      };
    case USER_CREATE:
      return {
        ...state,
        clientReady: false,
        _authError: null,
        _serverError: null,
      };
    case AUTHENTICATION_SUCCESS:
      return {
        ...state,
        clientReady: true,
        _authError: null,
        _serverError: null,
      };
    case AUTHENTICATION_ERROR:
      return {
        ...state,
        clientReady: false,
        _authError: action.record,
      };
    case DISCONNECTED:
      return {
        ...state,
        ready: false,
      };
    case CONNECTED:
      return {
        ...state,
        ready: true,
      };
    case SERVER_ERROR:
      return {
        ...state,
        ready: false,
        clientReady: false,
        _serverError: action.record.reason,
      };
    case PROACTIVE_TRIGGERED:
      return {
        ...state,
        proactiveTriggered: true,
      };
    default:
      return state;
  }
}

export function appInitialized() {
  return { type: APP_INITIALIZED };
}

export function clientAuthenticationSuccess(record) {
  return { type: AUTHENTICATION_SUCCESS, record };
}

export function clientAuthenticationError(record) {
  return { type: AUTHENTICATION_ERROR, record };
}

export function clientDisconnected() {
  return { type: DISCONNECTED };
}

export function clientConnected() {
  return { type: CONNECTED };
}

export function serverError(record) {
  return { type: SERVER_ERROR, record };
}

export const proactiveTriggered = () => ({ type: PROACTIVE_TRIGGERED });

// selectors
export const getAuthError = state => {
  return state._authError;
};

export const getProactiveTriggered = state => state.proactiveTriggered;

export const isClientReady = state => {
  return state.clientReady;
};

export const isAppInitialized = state => {
  return state.initialized;
};
